import React, { Component } from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react';
import { ActivityItem } from 'office-ui-fabric-react/lib/ActivityItem';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Modal } from 'office-ui-fabric-react/lib/Modal';

import { DataNews } from '../../data/DataNews.jsx';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

//#region CSS
const classNames = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '60vh',
        maxWidth: '500px',
        width: '60vw'
    },
    modalScrollableContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    modalHeader: {
        background: '#fd0400',
        color: 'white',
        padding: '8px 28px 0'
    },
    modalBody: {
        flex: '2 2',
        overflowY: 'auto',
        padding: '5px 28px'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 28px',
    },
    newsItem: { padding: '5px 0px' },
    newsTitre: { fontWeight: 'bold' },
    newsRecente: {
        color: '#fd0400',
        fontWeight: 'bold'
    }
});
//#endregion

export class ModalNews extends Component {

    constructor(props) {
        super(props);

        this._filterBy = { idTypeMandat: true };
        this._include = {};
        this._sortedColumn = "creerLe";
        this._isSortedDescending = true;

        this.state = {
            newsActivityItems: [],
            onAfficheModalNews: false
        }
    };

    _convertirNewsEnActivityItem = (news, key) => {
        const newsTitre = news.titre;
        const newsContenu = news.contenu;
        const newsCreerLe = news.creerLe;

        const convertedNews = {
            key: key,
            activityDescription: [
                <span key={1} className={classNames.newsTitre}> {newsTitre} </span>
            ],
            activityIcon: <Icon iconName={'Message'} />,
            comments: newsContenu,
            timeStamp: Scriba.date().stringDateFormatCourt(newsCreerLe)
        };

        const tenDaysAgo = new Date();
        tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
        if (tenDaysAgo < new Date(newsCreerLe))
            convertedNews.activityDescription.push(<span key={2} className={classNames.newsRecente}> nouveau ! </span>)

        return convertedNews;
    };

    componentDidMount = () => {
        let chargementNews = DataNews._onChargementNews(this._filterBy, this._include, this._sortedColumn, this._isSortedDescending);

        chargementNews
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    const objetData = responseFetch.reponseAPIobjet;
                    const activityItemsTemp = [];

                    if (objetData.length > 0) {
                        for (let i = 0; i < objetData.length; i++) {
                            activityItemsTemp.push(this._convertirNewsEnActivityItem(objetData[i], i + 1));
                        }
                    }

                    if (activityItemsTemp.length > 0)
                        this.setState({
                            newsActivityItems: activityItemsTemp,
                            onAfficheModalNews: true
                        });
                }
            });
    };

    render = () => {
        return <Modal
            isOpen={this.state.onAfficheModalNews}
            onDismiss={() => this.setState({ onAfficheModalNews: false })}
            containerClassName={classNames.modalContainer}
            scrollableContentClassName={classNames.modalScrollableContent}
        >
            <div className={classNames.modalHeader}>
                <h3>News</h3>
            </div>
            <div className={classNames.modalBody}>
                {this.state.newsActivityItems.map((item) => (
                    <ActivityItem {...item} key={item.key} className={classNames.newsItem} />
                ))}
            </div>
            <div className={classNames.modalFooter}>
                <DefaultButton onClick={() => this.setState({ onAfficheModalNews: false })} text="Fermer" />
            </div>
        </Modal>
    };

}
